import { render, staticRenderFns } from "./ComprehensivebusinessForm.vue?vue&type=template&id=69e5a473&scoped=true&"
import script from "./ComprehensivebusinessForm.vue?vue&type=script&lang=js&"
export * from "./ComprehensivebusinessForm.vue?vue&type=script&lang=js&"
import style0 from "./ComprehensivebusinessForm.vue?vue&type=style&index=0&id=69e5a473&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e5a473",
  null
  
)

export default component.exports